// extracted by mini-css-extract-plugin
export default {"wrapper":"Concept_wrapper__Dh0QY","boxWrapper":"Concept_boxWrapper__C8LuK","box":"Concept_box__DU4m2"};